import { useState, useCallback } from 'react';

/**
 * Custom hook for managing user modal states
 */
export const useUserModals = () => {
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [dependencyTree, setDependencyTree] = useState(null);
  const [loadingDependencies, setLoadingDependencies] = useState(false);

  const openAddModal = useCallback(() => {
    setSelectedUser(null);
    setShowModal(true);
  }, []);

  const closeAddModal = useCallback(() => {
    setShowModal(false);
    setSelectedUser(null);
  }, []);

  const openEditModal = useCallback((user) => {
    setSelectedUser(user);
    setShowModal(true);
  }, []);

  const openDeleteModal = useCallback((user) => {
    setSelectedUser(user);
    setShowDeleteModal(true);
    setDependencyTree(null);
  }, []);

  const closeDeleteModal = useCallback(() => {
    setShowDeleteModal(false);
    setSelectedUser(null);
    setDependencyTree(null);
  }, []);

  const handleDropdownClose = useCallback(() => {
    setOpenDropdown(null);
  }, []);

  return {
    showModal,
    showDeleteModal,
    selectedUser,
    openDropdown,
    dependencyTree,
    loadingDependencies,
    setSelectedUser,
    setShowModal,
    setShowDeleteModal,
    setOpenDropdown,
    setDependencyTree,
    setLoadingDependencies,
    openAddModal,
    closeAddModal,
    openEditModal,
    openDeleteModal,
    closeDeleteModal,
    handleDropdownClose
  };
};

